module.exports = __webpack_public_path__ + "resources/notify-009f4c0705b5c7a5a3c908ff39b09da5.svg";